// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-wrapper {
	height: 100vh;
	display: grid;
	grid-template-columns: 1fr 600px;
	width: 100%;
	background-color: var(--background);
}

.login__back {
	position: fixed;
	top: 20px;
	left: 20px;
	color: var(--text);
	font-size: 20px;
	cursor: pointer;
	width: 40px;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	background-color: var(--button);
	transition: 0.3s;
}

.login__back:hover {
	background-color: var(--button-hover);
	transition: 0.3s;
}

.login__form {
	display: flex;
	flex-direction: column;
	padding: 80px;
	height: 100vh;
	overflow-y: auto;
	position: relative;
	justify-content: center;
	gap: 24px;
}

.login-title {
	font-family: "Poppins", sans-serif;
	font-size: 32px;
	line-height: 42px;
	color: var(--dark);
}

.auth-form-label {
	font-size: 16px;
	line-height: 20px;
	color: var(--dark);
	font-family: "Poppins", sans-serif;
}

.auth-form-button {
	height: 56px !important;
	width: fit-content;
	border-radius: 12px !important;
	font-family: "Poppins", sans-serif !important;
	font-size: 18px;
	line-height: 22px;
	color: var(--background) !important;
	background-color: var(--button) !important;
	background: var(--button) !important;
	border: none;
	cursor: pointer;
	font-weight: 500;
	transition: 0.3s;
	min-width: 150px;
	box-shadow: unset !important;
}

.auth-form-button:disabled {
	opacity: 0.5 !important;
}

.auth-form-button:disabled:hover {
	background-color: var(--button) !important;
	background: var(--button) !important;
}

.auth-form-button:hover {
	background-color: var(--button-hover) !important;
	background: var(--button-hover) !important;
	transition: 0.3s;
}

.login__reset-password a {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: start;
	font-family: "Poppins", sans-serif !important;
	font-size: 16px;
	line-height: 20px;
	color: var(--dark) !important;
	text-decoration: underline !important;
}

@media (max-width: 1150px) {
	.login-wrapper {
		height: 100vh;
		display: grid;
		grid-template-columns: 1fr 450px;
		width: 100%;
		background-color: var(--background);
	}

	.login__form {
		display: flex;
		flex-direction: column;
		padding: 40px;
		height: 100vh;
		overflow-y: auto;
		position: relative;
		justify-content: center;
		gap: 24px;
	}
}

@media (max-width: 950px) {
	.login-wrapper {
		height: 100vh;
		display: grid;
		grid-template-columns: 1fr;
		width: 100%;
		background-color: var(--background);
	}

	.login__form {
		display: flex;
		flex-direction: column;
		padding: 50px 20px;
		height: 100vh;
		overflow-y: auto;
		position: relative;
		justify-content: center;
		gap: 24px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/LendingPage/Auth/Login/Login.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,aAAa;CACb,gCAAgC;CAChC,WAAW;CACX,mCAAmC;AACpC;;AAEA;CACC,eAAe;CACf,SAAS;CACT,UAAU;CACV,kBAAkB;CAClB,eAAe;CACf,eAAe;CACf,WAAW;CACX,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,+BAA+B;CAC/B,gBAAgB;AACjB;;AAEA;CACC,qCAAqC;CACrC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,aAAa;CACb,gBAAgB;CAChB,kBAAkB;CAClB,uBAAuB;CACvB,SAAS;AACV;;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,kCAAkC;AACnC;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;CAClB,8BAA8B;CAC9B,6CAA6C;CAC7C,eAAe;CACf,iBAAiB;CACjB,mCAAmC;CACnC,0CAA0C;CAC1C,oCAAoC;CACpC,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,0CAA0C;CAC1C,oCAAoC;AACrC;;AAEA;CACC,gDAAgD;CAChD,0CAA0C;CAC1C,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,sBAAsB;CACtB,6CAA6C;CAC7C,eAAe;CACf,iBAAiB;CACjB,6BAA6B;CAC7B,qCAAqC;AACtC;;AAEA;CACC;EACC,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,WAAW;EACX,mCAAmC;CACpC;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;CACV;AACD;;AAEA;CACC;EACC,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,mCAAmC;CACpC;;CAEA;EACC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;CACV;AACD","sourcesContent":[".login-wrapper {\n\theight: 100vh;\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 600px;\n\twidth: 100%;\n\tbackground-color: var(--background);\n}\n\n.login__back {\n\tposition: fixed;\n\ttop: 20px;\n\tleft: 20px;\n\tcolor: var(--text);\n\tfont-size: 20px;\n\tcursor: pointer;\n\twidth: 40px;\n\theight: 40px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 50%;\n\tbackground-color: var(--button);\n\ttransition: 0.3s;\n}\n\n.login__back:hover {\n\tbackground-color: var(--button-hover);\n\ttransition: 0.3s;\n}\n\n.login__form {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 80px;\n\theight: 100vh;\n\toverflow-y: auto;\n\tposition: relative;\n\tjustify-content: center;\n\tgap: 24px;\n}\n\n.login-title {\n\tfont-family: \"Poppins\", sans-serif;\n\tfont-size: 32px;\n\tline-height: 42px;\n\tcolor: var(--dark);\n}\n\n.auth-form-label {\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: var(--dark);\n\tfont-family: \"Poppins\", sans-serif;\n}\n\n.auth-form-button {\n\theight: 56px !important;\n\twidth: fit-content;\n\tborder-radius: 12px !important;\n\tfont-family: \"Poppins\", sans-serif !important;\n\tfont-size: 18px;\n\tline-height: 22px;\n\tcolor: var(--background) !important;\n\tbackground-color: var(--button) !important;\n\tbackground: var(--button) !important;\n\tborder: none;\n\tcursor: pointer;\n\tfont-weight: 500;\n\ttransition: 0.3s;\n\tmin-width: 150px;\n\tbox-shadow: unset !important;\n}\n\n.auth-form-button:disabled {\n\topacity: 0.5 !important;\n}\n\n.auth-form-button:disabled:hover {\n\tbackground-color: var(--button) !important;\n\tbackground: var(--button) !important;\n}\n\n.auth-form-button:hover {\n\tbackground-color: var(--button-hover) !important;\n\tbackground: var(--button-hover) !important;\n\ttransition: 0.3s;\n}\n\n.login__reset-password a {\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: start;\n\tfont-family: \"Poppins\", sans-serif !important;\n\tfont-size: 16px;\n\tline-height: 20px;\n\tcolor: var(--dark) !important;\n\ttext-decoration: underline !important;\n}\n\n@media (max-width: 1150px) {\n\t.login-wrapper {\n\t\theight: 100vh;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr 450px;\n\t\twidth: 100%;\n\t\tbackground-color: var(--background);\n\t}\n\n\t.login__form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding: 40px;\n\t\theight: 100vh;\n\t\toverflow-y: auto;\n\t\tposition: relative;\n\t\tjustify-content: center;\n\t\tgap: 24px;\n\t}\n}\n\n@media (max-width: 950px) {\n\t.login-wrapper {\n\t\theight: 100vh;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 1fr;\n\t\twidth: 100%;\n\t\tbackground-color: var(--background);\n\t}\n\n\t.login__form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding: 50px 20px;\n\t\theight: 100vh;\n\t\toverflow-y: auto;\n\t\tposition: relative;\n\t\tjustify-content: center;\n\t\tgap: 24px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
